import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Header from "components/Header/index";
import Sidebar from "containers/SideNav/index";
import Footer from "components/Footer";
import Dashboard from "./routes/dashboard";
import {
  ABOVE_THE_HEADER,
  BELOW_THE_HEADER,
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  HORIZONTAL_NAVIGATION,
} from "constants/ActionTypes";
import ColorOption from "containers/Customizer/ColorOption";
import { isIOS, isMobile } from "react-device-detect";
import asyncComponent from "../util/asyncComponent";
import TopNav from "components/TopNav";

class App extends React.Component {
  render() {
    const {
      match,
      drawerType,
      navigationStyle,
      horizontalNavPosition,
    } = this.props;
    const drawerStyle = drawerType.includes(FIXED_DRAWER)
      ? "fixed-drawer"
      : drawerType.includes(COLLAPSED_DRAWER)
      ? "collapsible-drawer"
      : "mini-drawer";

    //set default height and overflow for iOS mobile Safari 10+ support.
    if (isIOS && isMobile) {
      document.body.classList.add("ios-mobile-view-height");
    } else if (document.body.classList.contains("ios-mobile-view-height")) {
      document.body.classList.remove("ios-mobile-view-height");
    }

    return (
      <div className={`app-container ${drawerStyle}`}>
        {/* <Tour/> */}

        <Sidebar userMode="Applicant" authUser={this.props.authUser} />
        <div className="app-main-container">
          <div
            className={`app-header ${
              navigationStyle === HORIZONTAL_NAVIGATION
                ? "app-header-horizontal"
                : ""
            }`}
          >
            {navigationStyle === HORIZONTAL_NAVIGATION &&
              horizontalNavPosition === ABOVE_THE_HEADER && (
                <TopNav styleName="app-top-header" />
              )}
            <Header />
            {navigationStyle === HORIZONTAL_NAVIGATION &&
              horizontalNavPosition === BELOW_THE_HEADER && <TopNav />}
          </div>

          <main className="app-main-content-wrapper">
            <div className="app-main-content">
              <Switch>
                <Route path={`${match.url}/dashboard`} component={Dashboard} />
                <Route
                  path={`${match.url}/dashboard`}
                  component={asyncComponent(() => import("./routes/dashboard"))}
                />
                <Route
                  path={`${match.url}/olevel`}
                  component={asyncComponent(() => import("./routes/olevel"))}
                />

                <Route
                  path={`${match.url}/biodata`}
                  component={asyncComponent(() => import("./routes/biodata"))}
                />
                <Route
                  path={`${match.url}/utmeresult`}
                  component={asyncComponent(() =>
                    import("./routes/utmeresult")
                  )}
                />

                <Route
                  path={`${match.url}/results`}
                  component={asyncComponent(() => import("./routes/Results"))}
                />

                <Route
                  path={`${match.url}/nddetails`}
                  component={asyncComponent(() =>
                    import("./routes/nddetail/index.js")
                  )}
                />
                <Route
                  path={`${match.url}/documents`}
                  component={asyncComponent(() => import("./routes/documents"))}
                />
                <Route
                  path={`${match.url}/screeningfees`}
                  component={asyncComponent(() => import("./routes/screeningFee"))}
                />
                <Route
                  path={`${match.url}/probationalResult`}
                  component={asyncComponent(() => import("./routes/probationalResult"))}
                />
                <Route
                  path={`${match.url}/hostel`}
                  component={asyncComponent(() =>
                    import("./routes/ApplyForHostel")
                  )}
                />

                <Route
                  path={`${match.url}/admissiondocs`}
                  component={asyncComponent(() =>
                    import("./routes/admissiondocs")
                  )}
                />

                <Route
                  path={`${match.url}/guardian`}
                  component={asyncComponent(() =>
                    import("./routes/RefereeAproval")
                  )}
                />

                <Route
                  path={`${match.url}/changepassword/`}
                  component={asyncComponent(() =>
                    import("./routes/changepassword")
                  )}
                />

                <Route
                  path={`${match.url}/paymenthistory`}
                  component={asyncComponent(() =>
                    import("./routes/paymenthistory")
                  )}
                />
                <Route
                  path={`${match.url}/transactionstatus`}
                  component={asyncComponent(() =>
                    import("./transactionStatus")
                  )}
                />

                <Route
                  component={asyncComponent(() =>
                    import("app/routes/extraPages/routes/404")
                  )}
                />
              </Switch>
            </div>
            <Footer />
          </main>
        </div>
        <ColorOption />
      </div>
    );
  }
}

const mapStateToProps = ({ settings, auth }) => {
  const { drawerType, navigationStyle, horizontalNavPosition } = settings;
  const authUser = auth.applicantUser;
  return { drawerType, navigationStyle, horizontalNavPosition, authUser };
};
export default withRouter(connect(mapStateToProps)(App));
